var styles = {"tag":"styles_tag__1dJV-","default":"styles_default__fU9NG","complement1":"styles_complement1__ysdXX","complement2":"styles_complement2__SMtKA","accent":"styles_accent__sPVaL","gradient1":"styles_gradient1__ZZWgd","gradient2":"styles_gradient2__-N5iU","gradient3":"styles_gradient3__2rr05","gradient4":"styles_gradient4__vdboQ"};

export { styles as default };
//# sourceMappingURL=styles.css.js.map
